import actionCreator from "helpers/actionCreator"
import { createReducer } from "reduxsauce"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { DESC, orderState, handleSort } from "helpers/sorts"
import { pick } from "lodash"
import { isGroupedByMembership, getAdjustedContributorGrouping } from "helpers/rollups"
import { ANALYZE_SECTION, createAnalyzeGroupingAndFilterReducer } from "helpers/analyze"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeRiskDetails", {
  show: {
    props: ["item"],
    track: true,
    trackType: "analyze-risk-contributors-category-selected",
    trackPayload: ({ item: { label } }) => ({ type: label }),
  },
  hide: [],
  sort: {
    props: ["order"],
    track: true,
    trackType: "analyze-risk-contributors-sorting",
    trackPayload: ({ order }) => order,
  },
  showGroup: {
    props: ["group"],
    track: true,
    trackType: "analyze-risk-contributors-group-selected",
    trackPayload: ({ group: { name } }) => ({ label: name }),
  },
  hideGroup: [],
  setContributorsGrouping: {
    props: ["grouping"],
    track: true,
    trackType: "analyze-risk-contributors-grouping-option-selected",
    trackPayload: ({ grouping }) => {
      let by
      if (grouping) {
        by = grouping.classificationId
          ? `${grouping.classificationId} - ${grouping.id}` : grouping.id
      }
      return { by }
    },
  },
  groupSort: {
    props: ["order"],
    track: true,
    trackType: "analyze-risk-contributors-group-sorting",
    trackPayload: ({ order }) => ({ order }),
  },
})

const defaultOrder = orderState("viewType", DESC)

const DEFAULT_STATE = {
  selected: null,
  order: defaultOrder,
  selectedGroup: null,
  contributorsGrouping: null,
  groupOrder: {
    by: "value",
    order: "desc",
  },
}

function handleShow(state, { item }) {
  return { ...state, selected: item }
}

function handleHide(state) {
  return {
    ...state,
    selected: null,
    order: defaultOrder,
  }
}

function handleGroupSort(state, { order }) {
  return { ...state, groupOrder: { ...state.groupOrder, order } }
}

function handleShowGroup(state, { group }) {
  return { ...state, selectedGroup: pick(group, ["id", "name", "description"]) }
}

function handleHideGroup(state) {
  return { ...state, selectedGroup: null }
}

function handleSetContributorsGrouping(state, { grouping }) {
  let contributorsGrouping
  if (grouping) {
    contributorsGrouping = grouping
  }
  return { ...state, contributorsGrouping, selectedGroup: null }
}

function handleSetModel(state) {
  return { ...state, ...DEFAULT_STATE }
}

function handleSetSelectedBase(state, { selectedBase }) {
  if (isGroupedByMembership(state.contributorsGrouping)) {
    return { ...state, contributorsGrouping: null }
  }
  return { ...state, contributorsGrouping: getAdjustedContributorGrouping(state.contributorsGrouping, !!selectedBase) }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SORT]: handleSort,
  [Types.SHOW]: handleShow,
  [Types.HIDE]: handleHide,
  [Types.SHOW_GROUP]: handleShowGroup,
  [Types.HIDE_GROUP]: handleHideGroup,
  [Types.SET_CONTRIBUTORS_GROUPING]: handleSetContributorsGrouping,
  [Types.GROUP_SORT]: handleGroupSort,
  [BaseTypes.SET_MODEL]: handleSetModel,
  [BaseTypes.SET_SELECTED_BASE]: handleSetSelectedBase,
  ...createAnalyzeGroupingAndFilterReducer(ANALYZE_SECTION.TRENDS),
})
